<div class="notification-floating-panel pt-4">
  <!-- Header sticky -->
  <span class="text-lg font-semibold pb-3 border-b-1 border-solid border-[#1c27315c] px-4">Notificaciones y actividades</span>

  <!-- Scrollable content -->
  <div class="panel-content">
    <!-- Skeleton loader -->
    <ng-container *ngIf="isLoading">
      <div *ngFor="let s of [1,2,3]" class="px-4 py-3 gap-4 grid grid-cols-[auto_1fr_auto] border-b border-gray-100">
        <div class="flex items-center gap-2">
          <ion-skeleton-text [animated]="true" class="rounded-md w-3 h-3"></ion-skeleton-text>
          <ion-skeleton-text [animated]="true" class="rounded-md w-8 h-8"></ion-skeleton-text>
        </div>
        <div class="grid gap-2">
          <ion-skeleton-text [animated]="true" class="rounded-md h-4 w-full"></ion-skeleton-text>
          <ion-skeleton-text [animated]="true" class="rounded-md h-3 w-2/3"></ion-skeleton-text>
        </div>
        <div class="flex items-center justify-end">
          <ion-skeleton-text [animated]="true" class="rounded-md w-5 h-5"></ion-skeleton-text>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="!isLoading && notifications">
      <div *ngFor="let notificationGroup of notifications">
        <span class="text-lg px-4 pt-3 block font-semibold">{{ notificationGroup?.date }}</span>
        <!-- card -->
        <div *ngFor="let notification of notificationGroup.notifications"
          (click)="onNotificationClick(notification)"
          class="px-4 py-3 gap-4 grid grid-cols-[auto_1fr_auto] cursor-pointer transition-colors duration-200 hover:bg-secondary_super_ultra_light_variant"
          [ngClass]="{
            'bg-secondary_super_ultra_light_variant': !notification.is_read,
            'bg-white': notification?.is_read
          }">
          <!-- icono -->
          <div class="text-primary flex items-center gap-2">
            <ion-icon name="ellipse" class="text-xxs"
              [ngClass]="notification?.is_read ? 'opacity-0 text-transparent' : 'color-custom-red'"></ion-icon>
            <mat-icon class="mdi text-primary mx-2 text-xl"
              [ngClass]="notificationsActivitiesService.iconNotification(notification?.type?.code)"></mat-icon>
          </div>
          <!-- texto -->
          <div class="grid grid-cols-[1fr] gap-2 items-center">
            <span class="font-normal text-sm" [innerHtml]="notification?.content"></span>
            <div class="flex justify-start items-center gap-3">
              <app-chip *ngIf="notification?.signaturePending" customClass="px-2 py-1 border-1" borderColor="#FE4242"
                bgColor="#ffffff">
                <span
                  class="no-wrap-chip-comp text-[#FE4242] text-xxs leading-[10px] font-medium flex justify-center items-center">
                  Firma pendiente
                </span>
              </app-chip>
              <p *ngIf="notification?.endDate"
                class="text-primary text-xs px-2 py-1 bg-white rounded-lg flex items-center justify-center">
                Hasta {{ notification?.endDate | date:'dd/MM/yyyy' }}
              </p>
            </div>
          </div>
          <!-- arrow -->
          <div class="flex items-center justify-end">
            <mat-icon class="mdi mdi-chevron-right text-xl"></mat-icon>
          </div>
        </div>
      </div>
    </ng-container>

    <div *ngIf="!isLoading && (!notifications || notifications?.length === 0)" class="h-[50vh] w-full m-auto flex flex-col justify-center items-center gap-6">
			<!-- <IconSvg name="notifications-undraw" customClass="w-34 h-34 text-primary"></IconSvg> -->
      <app-image-svg name="notifications-image" customClass="w-48" ></app-image-svg>
      <span *ngIf="language === 'es'" class="text-center block">
        No tienes <b>notificaciones</b> por el momento.
      </span>
      <span *ngIf="language === 'en'" class="text-center block">
        You have no <b>notifications</b> at the moment.
      </span>
    </div>
  </div>

  <!-- Footer sticky -->
  <div *ngIf="notifications && notifications.length > 0" class="panel-footer bg-[#F6F6FE]" (click)="onGoToFullView()">
    <span class="text-primary text-sm font-medium cursor-pointer ">Ver en pantalla completa</span>
  </div>
</div>
